export const SET_VALUE = (state, value) => {
  state[value.key] = value.value
}

export const SET_SELECTED = (state, value) => {
  state.selected = value
}
